"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_loops_1 = require("react-loops");
const utils_1 = require("../../utils");
exports.CenteredRow = (_a) => {
    var { children, className } = _a, props = tslib_1.__rest(_a, ["children", "className"]);
    const renderedChildren = children.map(col => {
        return react_1.default.isValidElement(col)
            ? {
                grow: false,
                render: col,
            }
            : col;
    });
    return (react_1.default.createElement("div", Object.assign({}, props, { className: utils_1.classnames('d-flex flex-row', className) }),
        react_1.default.createElement(react_loops_1.For, { of: renderedChildren, as: (col, { index }) => (react_1.default.createElement("div", Object.assign({ className: utils_1.classnames('flex-col-centered', {
                    'flex-grow-1': col.grow,
                }) }, (col.props || {}), { key: `col-${index}` }), col.render)) })));
};
//# sourceMappingURL=CenteredRow.js.map